// 节点类型路径映射配置 - 更新为重构后的文件结构
export const NODE_PATHS = {
  // 触发类节点 - 使用统一的模块导出
  triggers: {
    initialNode: './triggers',
    timerTrigger: './triggers'
  },
  // 输入类节点 - 使用统一的模块导出
  inputs: {
    jsonInput: './inputs',
    formInput: './inputs', 
    arrayInput: './inputs'
  },
  // 处理类节点 - 使用统一的模块导出
  processing: {
    customFunction: './processing',
    debugNode: './processing'
  },
  // HTTP类节点 - 仍然采用字符串路径（动态加载仅用于逻辑类）
  http: {
    httpRequest: './http/httpRequest',
    fetchRequest: './http/fetchRequest',
    webSocketClient: './http/webSocketClient'
  },
  // 资源类节点 - 动态加载逻辑类
  resources: {
    resourceGet: './resources/resourceGet'
  },
  // 变量类节点 - 动态加载逻辑类
  variables: {
    variableGet: './variables/variableGet',
    variableSet: './variables/variableSet'
  }
};

// 节点类名映射 - 用于从模块中获取正确的类
export const NODE_CLASS_NAMES = {
  triggers: {
    initialNode: 'InitialNode',
    timerTrigger: 'TimerTriggerNode'
  },
  inputs: {
    jsonInput: 'JsonInput',
    formInput: 'FormInput',
    arrayInput: 'ArrayInput'
  },
  processing: {
    customFunction: 'CustomFunction',
    debugNode: 'DebugNode'
  },
  // 为 http 类添加逻辑类名映射（组件不走动态加载）
  http: {
    httpRequest: 'HttpRequest',
    fetchRequest: 'FetchRequest',
    webSocketClient: 'WebSocketClient'
  },
  // 资源类
  resources: {
    resourceGet: 'ResourceGet'
  },
  // 变量类
  variables: {
    variableGet: 'VariableGet',
    variableSet: 'VariableSet'
  }
};

// 节点组件名映射 - 仅限可从模块命名导出的组件（SFC 不适用）
export const NODE_COMPONENT_NAMES = {
  triggers: {
    initialNode: 'InitialNodeComponent',
    timerTrigger: 'TimerTriggerComponent'
  },
  inputs: {
    jsonInput: 'JsonInputComponent',
    formInput: 'FormInputComponent',
    arrayInput: 'ArrayInputComponent'
  },
  processing: {
    customFunction: 'CustomFunctionComponent',
    debugNode: 'DebugNodeComponent'
  }
};